import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import { uploadCsvCustomWatchlist } from "../../actions";
import UploadCsvCustomWatchlistForm from "../../components/upload-csv-custom-watchlist-form";

import "./uploadCustomWatchlistPage.css";
import { PageTitle } from "../../../../components/common";

const UploadCustomWatchlistPage = () => {
  const [initialUploadCsvCustomWatchlist, setInitialUploadCsvCustomWatchlist] =
    useState({ csvFile: undefined, randomNum: Date.now() });

  const dispatch = useDispatch();

  const handleSubmit = (data) => {
    dispatch(uploadCsvCustomWatchlist(data));
    setInitialUploadCsvCustomWatchlist({ csvFile: "", randomNum: Date.now() });
  };

  return (
    <Container className="col-12 p-0">
      <PageTitle title="upload custom watchlist" className="mb-5"/>
      <Row>
        <Col lg={12}>
          <UploadCsvCustomWatchlistForm
            title="Upload Csv Clients"
            handleSubmit={handleSubmit}
            initialUploadCsvCustomWatchlist={initialUploadCsvCustomWatchlist}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default UploadCustomWatchlistPage;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/pages/upload-custom-watchlist-page/UploadCustomWatchlistPage.jsx